var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-img',{staticClass:"image_logo",attrs:{"width":"250px","src":require("../../assets/logo.svg")}}),_c('v-img',{staticClass:"image_sologan",attrs:{"width":"240px","src":require("../../assets/sologan.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }